import { useQuery } from 'react-query'
import { getAssignableSubtasks } from '../../core/_requests'

export function useGetAssignableSubtasks({search}: {search: string}) {
  return useQuery(
    ['assignable-subtasks', search],
    async () => (await getAssignableSubtasks(search)).data,
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: true,
    }
  )
}